export default __webpack_public_path__ + "/images/hat-with-names.png";